/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/training.scss';
import PopTeacherTrainingDetail from './_PopTeacherTrainingDetail';

const TeacherTraining = () => {
  const [modalManageTrainingProgram, setModalManageTrainingProgram] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);

  const navigate = useNavigate();
  return (
    <main className="com_container com_training p_teacher_training">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_3">신규 교사 교육 관리</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_calendar_wrap ">
              <div className="year">
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
              </div>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                </colgroup>
                <thead>
                  <tr>
                    <th colSpan="2">구분</th>
                    <th>
                      1기
                      <br /> (~01/27)
                    </th>
                    <th>
                      2기
                      <br />
                      (~03/03)
                    </th>
                    <th>
                      3기
                      <br />
                      (~04/01)
                    </th>
                    <th>
                      4기
                      <br />
                      (~04/28)
                    </th>
                    <th className="highlight">
                      5기
                      <br />
                      (~06/02)
                    </th>
                    <th>
                      6기
                      <br />
                      (~06/30)
                    </th>
                    <th>
                      7기
                      <br />
                      (~08/04)수
                    </th>
                    <th>
                      8기
                      <br />
                      (~9/2)
                    </th>
                    <th>
                      9기
                      <br />
                      (~9/29)
                    </th>
                    <th>
                      10기
                      <br />
                      (~10/20)
                    </th>
                    <th>
                      11기
                      <br />
                      (~11/17)
                    </th>
                    <th>
                      12기
                      <br />
                      (~12/13)
                    </th>
                    <th>합산</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan="8" className="light_gray bold">
                      과목별
                      <br />
                      교육 수료
                      <br />
                      교사
                    </td>
                    <td className="light_gray">국어</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">수학</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">영어</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">사탐</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">과탐</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">원격</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">논술</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr>
                    <td className="border_left light_gray">원/논</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>0</td>
                    <td className="highlight">0</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>4</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td className="td_point light_gray">21</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2" className="bold">
                      총원
                    </td>
                    <td>45</td>
                    <td>212</td>
                    <td>45</td>
                    <td>212</td>
                    <td className="highlight">45</td>
                    <td>212</td>
                    <td>45</td>
                    <td>212</td>
                    <td>45</td>
                    <td>212</td>
                    <td>45</td>
                    <td>212</td>
                    <td className="td_point">21</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2" className="bold">
                      우수
                    </td>
                    <td>45</td>
                    <td>212</td>
                    <td>123</td>
                    <td>456</td>
                    <td className="highlight">645</td>
                    <td>65</td>
                    <td>24</td>
                    <td>240</td>
                    <td>51</td>
                    <td>55</td>
                    <td>55</td>
                    <td>55</td>
                    <td className="td_point">212</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2" className="bold">
                      미비
                    </td>
                    <td>7</td>
                    <td>212</td>
                    <td>123</td>
                    <td>456</td>
                    <td className="highlight">645</td>
                    <td>65</td>
                    <td>24</td>
                    <td>240</td>
                    <td>51</td>
                    <td>55</td>
                    <td>55</td>
                    <td>55</td>
                    <td className="td_point">212</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2" className="bold">
                      재교육
                    </td>
                    <td>45</td>
                    <td>212</td>
                    <td>123</td>
                    <td>456</td>
                    <td className="highlight">645</td>
                    <td>65</td>
                    <td>24</td>
                    <td>240</td>
                    <td>51</td>
                    <td>55</td>
                    <td>55</td>
                    <td>55</td>
                    <td className="td_point">212</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2" className="bold">
                      입사포기
                    </td>
                    <td className="td_red">0</td>
                    <td className="td_red">0</td>
                    <td className="td_red">1</td>
                    <td className="td_red">0</td>
                    <td className="highlight td_red">1</td>
                    <td className="td_red">0</td>
                    <td className="td_red">1</td>
                    <td className="td_red">0</td>
                    <td className="td_red">1</td>
                    <td className="td_red">0</td>
                    <td className="td_red">0</td>
                    <td className="td_red">0</td>
                    <td className="td_red">7</td>
                  </tr>
                  <tr>
                    <td colSpan="2" className="light_gray bold">
                      진행상태
                    </td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td className="highlight">13 / 15</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td>진행완료</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan="2" className="light_gray bold">
                      출석부
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td className="highlight">
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Training/TeacherTraining/Detail')} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan="2" className="light_gray bold">
                      상세보기
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td className="highlight">
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalDetail(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td>
                      <button onClick={() => setModalManageTrainingProgram(true)} className="btn_link blue">
                        보기
                      </button>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section className="box full">
            <div className="info_row">
              <div className="info_label">총 계약자</div>
              <div className="info_value">206명</div>
            </div>
            <div className="info_row">
              <div className="info_label">유지자</div>
              <div className="info_value">166명</div>
            </div>
            <div className="info_row">
              <div className="info_label">평균 수업진행률</div>
              <div className="info_value">75% 이상</div>
            </div>
            <div className="info_row">
              <div className="info_label">우수 신규교사</div>
              <div className="info_value">22명 (14.56%)</div>
            </div>
            <div className="info_row">
              <div className="txt label">국어(2) :</div>
              <div className="txt value">문상연, 최선지</div>
              <div className="txt label">수학(3) :</div>
              <div className="txt value"> 조윤희, 명형환, 염우진</div>
              <div className="txt label">영어(5) :</div>
              <div className="txt value">김경민, 윤수정, 전정호, 표성협, 우민호</div>
              <div className="txt label">과탐(4) :</div>
              <div className="txt value">고지연, 손세용, 장지영, 정윤제</div>
              <div className="txt label">화상(6) :</div>
              <div className="txt value">정선기, 김예지, 김명진, 이정후, 이헌수, 조정현</div>
            </div>
          </section>
        </section>
      </div>
      <PopTeacherTrainingDetail open={modalDetail} close={() => setModalDetail(false)} />
    </main>
  );
};

export default TeacherTraining;
